import { useCallback, useEffect, useRef, useState } from 'react';

export function useIndex({ maxIndex }) {
  const [index, setIndex] = useState(0);

  const decrementDisabled = index === 0;
  const incrementDisabled = index === maxIndex;

  const decrement = useCallback(() => setIndex((prev) => Math.max(prev - 1, 0)), []);
  const increment = useCallback(() => setIndex((prev) => Math.min(prev + 1, maxIndex)), [maxIndex]);

  return ({
    decrement,
    decrementDisabled,
    increment,
    incrementDisabled,
    index,
    setIndex,
  });
}

export function usePrevious(value) {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
